import { Market } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Market>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const marketsReducer = createReducer<State, Actions>(initialState, {
  [actions.getMarkets.request.type]: actionsHandlers.handleGetPaginatedManyRequest,
  [actions.getMarkets.success.type]: actionsHandlers.handleGetPaginatedManySuccess,
  [actions.getMarkets.failure.type]: actionsHandlers.handleGetPaginatedManyFailure,
  [actions.getMarkets.reset.type]: actionsHandlers.handleGetPaginatedManyReset,
});

export default marketsReducer;
